import { createStore } from 'vuex'

import timeModule from "./modules/time-module";
import themeModule from "./modules/theme-module";
import requestModule from "./modules/request-module";
import approvalModule from "./modules/approval-module";
import expenseModule from "./modules/expense-module";
import expenseSyncModule from "./modules/expense-sync-module";
import reportingModule from "./modules/reporting-module";
import adminModule from "./modules/admin-module";
import LoginModule from "@/store/modules/login-module.js";
import KazangModule from "@/store/modules/Kazang-module.js";
import paymentModule from "@/store/modules/payment-module.js";
import notificationModule from "./modules/notification-module.js";
import subscriptionModule from "./modules/subscription-module";
import kazangSessionModule from "./modules/kazang-session-module";
import timeManager from "@/services/TimeManager.js";

import VuexPersistence from "vuex-persist";
import {set, get , del} from 'idb-keyval';

const indexedDBStorage={
  getItem : async (key)=>{
    const value = await get(key);
    console.log('Getting from Indexed DB Storage' , {key,value});
    return value;
  },
  setItem : async (key, value)=>{
    console.log('Saving to IndexedDB Storage' , {key,value});
    await set(key, value);
  },
  removeItem : async (key)=>{
    console.log('Removing from IndexedDB Storage' , key);
    await del(key);
  }
}

const vuexLocal = new VuexPersistence({
  storage: indexedDBStorage,
  asyncStorage : true,
  restoreState : async (key) => {
    try {
      let value = await get(key);
      console.log('Restoring state from IndexedDB:', { key, value });
      if (value) {
        if (typeof value === `string`) {
          value = JSON.parse(value)
        }
        value.loading = false;
        value.isHydrated = true;
        return value;
      }
      return { isHydrated: true };
    } catch (err) {
      console.error('Error restoring state:', err);
      return {};
    }
  },
  saveState: async (key, value) => {
    try {
      const cleanState = cleanUpState(value);
      // console.log('Saving state to IndexedDB:', { key, value });
      await set(key, cleanState);
    } catch (err) {
      console.error('Error saving state:', err);
    }
  }
})

function cleanUpState(state) {
  return JSON.parse(JSON.stringify(state));
}

export default createStore({
  state: {
    loading: false,
    isHydrated : false,
  },
  getters: {
    getLoadingState: (state) => state.loading,
    isHydrated: (state) => state.isHydrated,
  },
  mutations: {
    setLoadingState: (state, payload) => state.loading = payload,
    setAuth: (state, payload) => state.auth = payload,
  },
  actions: {
    sendRequest(context, {url, payload, headers = {}, method = 'post'}) {
      const maxRetries = 3;
      let currentRetry = 0;
      if (!payload.localid){
        payload.localid = generateUUID();
      }

      const attemptRequest = async () => {
        return await axios[method](url, payload, {
          headers: headers || {}
        }).then(({data}) => {
          if (!data.processed) {
            // Check if the response indicates unprocessed data and if retries are available
            if (currentRetry < maxRetries) {
              currentRetry++;
              console.log(`Attempt ${currentRetry}: Data unprocessed, retrying...`);
              return attemptRequest(); // Retry the request
            }
            // Throw an error if max retries are reached with unprocessed data
            throw new Error('Data still unprocessed after maximum retries : ' + maxRetries);
          }
          payload.localid = null;
          return data.response; // Return the response if data is processed
        }).catch(err => {
          if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
            if (currentRetry < maxRetries) {
              currentRetry++;
              console.log(`Attempt ${currentRetry}: Retrying...`);
              return attemptRequest();
            }
          }
          throw err;
        });
      };
      return attemptRequest()
        .then(response => {
          payload.localid = null;
          return response
        })
        .catch(err => errorHandler.tomcatError(err));
    }
  },
  modules: {
    timeModule,
    theme: themeModule,
    requestModule,
    approvalModule,
    expenseModule,
    expenseSyncModule,
    reportingModule,
    adminModule,
    LoginModule,
    timeManager,
    KazangModule,
    kazangSession: kazangSessionModule,
    paymentModule,
    notificationModule,
    subscriptionModule,
  },

  plugins:[
    vuexLocal.plugin,
  ]
})
